import React from "react";
import { SearchForm } from "./searchForm"
import MaterielList from "./materielList"
const Materiel = (): JSX.Element => {
    return (
        <>
            <SearchForm />
            <MaterielList/>
        </>
    )
}
export default Materiel